import { css } from 'linaria';

export const documentItem = css`
  --button-hover-bg: var(--background-secondary) !important;
  padding: var(--space-100) var(--space-400) !important;
  border-radius: 0px;
  justify-content: flex-start;
  align-items: flex-start;

  & > span {
    display: flex;
    gap: var(--space-150);
    white-space: normal !important;
  }
`;

export const documentItemContent = css`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: var(--space-25);
`;

export const documentItemIcon = css`
  line-height: 0;
  flex-shrink: 0;
  padding: var(--space-100);
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-minor);
`;
